import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Stare',
      fields: {
        delivery_visible: {
          label: 'Livrare vizibilă',
        },
        has_delivery: {
          label: 'Livrare',
        },
        delivery_enabled: {
          label: 'Livrare activă',
        },
      },
    },
    delivery_mode: {
      title: 'Mod livrare',
      fields: {
        delivery_mode: {
          options: {
            [DeliveryMode.Internal]: 'Flotă de șoferi proprie',
            [DeliveryMode.External]: 'Flotă externă de șoferi ({{providers}})',
          },
        },
        external_delivery_pickup_note: {
          label: 'Notă preluare pentru șofer',
          placeholder: 'Informații utile de preluare pentru șofer (ex. cum să găsească intrarea etc.)',
        },
        instant_print_enabled: {
          label: 'Tipărire bon fără a aștepta șoferul',
        },
        provider_not_connected: {
          wolt_drive: 'Încă nu este conectat: acest restaurant nu are un ID de local Wolt valid.',
          connects_on_external:
            '{{provider}} este conectat după ce modul de livrare este setat la șoferi externi și salvat.',
          not_connected_yet:
            '{{provider}} nu este încă conectat pentru acest restaurant. Dacă acest lucru nu se schimbă, contactați asistența.',
        },
      },
    },
    scheduled_orders: {
      title: 'Comenzi programate',
      fields: {
        has_scheduled_orders: {
          label: 'Permiteți clienților să comande în avans pentru ore specifice?',
        },
        min_schedule_ahead_time_delivery: {
          label: 'Timp minim (minute) în avans pentru programarea comenzilor de <strong>livrare</strong>',
          placeholder: '60',
          validation_name: 'Timp minim de programare livrare',
          external_hint: 'Cu livrare externă, acesta trebuie să fie de cel puțin {{minutes}} minute (2 ore). ',
        },
        last_order_gap_delivery: {
          label: 'Ultima oră posibilă de comandă pentru <strong>livrare</strong> (minute înainte de închidere)',
          option: '{{value}} min',
        },
      },
    },
    delivery_info: {
      title: 'Info livrare',
      fields: {
        average_order_delivery_time_min: {
          label: 'Timp de livrare',
          placeholder: 'Timp în minute',
        },
        average_order_delivery_time_max: {
          label: 'până la',
          placeholder: 'Opțional',
        },
      },
    },
    delivery_zones: {
      title: 'Zone de livrare',
    },
  },
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    at_least_one_order_method_required:
      'Cel puțin 1 metodă de comandă (programată sau imediată) trebuie să fie activată. Nu le puteți dezactiva pe ambele.',
  },
};
